<template>

  <CommonPrivateView>
    <template v-slot:header>
      
      <div class="w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]">
        <div v-if="usuarioEmpresa">{{usuarioEmpresa.empresa.razonSocial}}</div>
      </div>

      <!-- Selección de grupos -->
      <div class="w-full">
        <div class="w-full" v-if="gruposInvitaciones?.length > 1">
          <div class="flex flex-col md:flex-row space-x-0 md:space-x-2 space-y-2 md:space-y-0">              
            <div v-for="grupoInvitacion in gruposInvitaciones" v-bind:key="grupoInvitacion.id" :grupoInvitacion="grupoInvitacion">
              <a @click="cambiarGrupoInvitacion(grupoInvitacion)"  class="block text-center cursor-pointer py-2 px-4 rounded border" :class="{'border-gray-100 bg-black text-white': grupoInvitacionSeleccionado?.id == grupoInvitacion.id, 'border-black bg-white text-black': grupoInvitacionSeleccionado?.id != grupoInvitacion.id}">
                <font-awesome-icon :icon="['far', 'circle-check']" v-if="grupoInvitacionSeleccionado?.id == grupoInvitacion.id" />
                <font-awesome-icon :icon="['far', 'circle']" v-if="grupoInvitacionSeleccionado?.id != grupoInvitacion.id" />
                {{grupoInvitacion.descripcion.toUpperCase()}} 
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin selección de grupos -->

      <!-- Estadísticas -->
      <div class="w-full flex flex-col lg:flex-row gap-4 lg:gap-4 mt-4">
        <div class="w-full lg:w-6/12 xl:w-4/12">
          <div class="relative flex flex-col min-w-0 break-words bg-white rounded-lg shadow-lg">
            <div class="flex-auto p-4">
              <div class="flex flex-wrap">
                <div class="relative w-auto pr-4 flex-initial">
                  <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-blue-900">
                    <font-awesome-icon :icon="['fas', 'ticket']" />
                  </div>
                </div>                        
                <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                  <h5 class="text-gray-700 uppercase font-bold text-xs">
                    Total asignadas 
                  </h5>
                  <span class="font-semibold text-2xl text-gray-600">
                    {{grupoInvitacionSeleccionado?.totalInvitaciones || 0}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full lg:w-6/12 xl:w-4/12">
          <div class="relative flex flex-col min-w-0 break-words bg-white rounded-lg shadow-lg">
            <div class="flex-auto p-4">
              <div class="flex flex-wrap">
                <div class="relative w-auto pr-4 flex-initial">
                  <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-orange-600">
                    <font-awesome-icon :icon="['far', 'circle-check']" />
                  </div>
                </div>                        
                <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                  <h5 class="text-gray-700 uppercase font-bold text-xs">
                    Usadas
                  </h5>
                  <span class="font-semibold text-2xl text-gray-600">
                    {{grupoInvitacionSeleccionado?.totalUsadas || 0}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full lg:w-6/12 xl:w-4/12">
          <div class="relative flex flex-col min-w-0 break-words bg-white rounded-lg shadow-lg">
            <div class="flex-auto p-4">
              <div class="flex flex-wrap">
                <div class="relative w-auto pr-4 flex-initial">
                  <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-green-900">
                    <font-awesome-icon :icon="['far', 'circle']" />
                  </div>
                </div>                        
                <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                  <h5 class="text-gray-700 uppercase font-bold text-xs">
                    Total disponibles
                  </h5>
                  <span class="font-semibold text-2xl text-gray-600">
                    {{grupoInvitacionSeleccionado?.totalDisponibles || 0}}
                  </span>
                </div>                        
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin estadísticas --> 

    </template>
    <template v-slot:content>
      
      <div class="container w-full mx-auto">

          <!-- FORM GESTIÓN INVITACIONES -->
          <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5 mt-4">              
            <div class="flex items-center justify-between font-semibold text-lg ">
              GESTIÓN DE ACREDITADOS
            </div>

            <div class="container mx-auto block w-full mt-4 space-y-4">

              <div class="w-full flex flex-col md:flex-row text-center lg:flex-row gap-2">
                <a @click="verUsadas" v-if="grupoInvitacionSeleccionado?.secuencia" class="cursor-pointer hover:bg-green-800 hover:text-white" :class="{'py-2 px-4 rounded border border-green-600 bg-green-600 text-white': verInvitacionesUsadas, 'py-2 px-4 rounded border border-green-600 bg-white text-green-600': !verInvitacionesUsadas}">
                  <font-awesome-icon :icon="['far', 'circle-check']" v-if="verInvitacionesUsadas" />
                  <font-awesome-icon :icon="['far', 'circle']" v-if="!verInvitacionesUsadas" />
                  VER USADAS
                </a>
                <a @click="verDisponibles" v-if="grupoInvitacionSeleccionado?.secuencia" class="cursor-pointer hover:bg-green-800 hover:text-white" :class="{'py-2 px-4 rounded border border-green-600 bg-green-600 text-white': !verInvitacionesUsadas, 'py-2 px-4 rounded border border-green-600 bg-white text-green-600': verInvitacionesUsadas}">
                  <font-awesome-icon :icon="['far', 'circle-check']" v-if="!verInvitacionesUsadas" />
                  <font-awesome-icon :icon="['far', 'circle']" v-if="verInvitacionesUsadas"/>
                  VER DISPONIBLES
                </a>
                <a @click="agregarInvitado" v-if="!grupoInvitacionSeleccionado?.secuencia" class="cursor-pointer py-2 px-4 rounded border border-green-600 bg-white text-green-600 hover:bg-green-800 hover:text-white">
                  <font-awesome-icon :icon="['fas', 'plus']" /> AGREGAR ACREDITADO
                </a>
                <a @click="downloadExcel" class="cursor-pointer py-2 px-4 rounded border border-green-600 bg-white text-green-600 hover:bg-green-800 hover:text-white">
                  <font-awesome-icon :icon="['far', 'file-excel']" /> EXCEL
                </a>
              </div>

              <div class="w-full flex flex-col">
                <InputGroup>
                  <InputText @keyup="filtrar" v-model="filtroTexto" placeholder="Buscar..." class="input-group-base bg-gray-50" />
                  <Button @click="limpiarFiltro" icon="pi pi-times" class="border borde-red-700 bg-red-700 text-white hover:bg-transparent hover:text-red-700 hover:border-red-700" />
                </InputGroup>
              </div>

              <DataView :value="invitacionesFiltradas" paginator :rows="16" :alwaysShowPaginator="false" class="mb-3" dataKey="item.id">
                <template #empty>
                    <div class="grid grid-cols-1 py-5 text-2xl font-semibold text-center text-gray-500 bg-white">
                        No hay invitaciones asignadas
                    </div>
                </template>
                <template #list="slotProps">
                  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm bg-white">

                    <div v-for="(item, index) in slotProps.items" :key="index">
                      <div class="p-3 w-full bg-gray-50 text-gray-500 dark:bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">
                      
                        <div class="flex flex-col w-full">
                          <div>
                            <font-awesome-icon v-if="item.acreditado" :icon="['far', 'user']" class="w-6 h-6 text-green-800 dark:text-green-800" />
                            <font-awesome-icon v-if="!item.acreditado" :icon="['fas', 'user']" class="w-6 h-6 text-red-800 dark:text-red-800"  />
                          </div>
                          <div>
                            <span v-if="item.acreditado" class="text-lg font-bold text-green-800 dark:text-green-800"> {{ item.codigoInvitacion }} </span>
                            <span v-if="!item.acreditado" class="text-lg font-bold text-red-800 dark:text-red-800"> {{ item.codigoInvitacion }} </span>
                          </div>
                          <div class="font-semibold">
                            {{ item.acreditado?.codigoAcreditado }}
                          </div>
                          <div :class="{'text-red-500 font-semibold': !item.acreditado?.dni, 'text-gray-500 dark:text-gray-500': item.acreditado?.dni}">
                            <div v-if="item.acreditado">{{ item.acreditado?.dni || 'SIN DNI' }}</div> 
                            <div v-if="!item.acreditado">{{ '' }}</div> 
                          </div>
                          <div>
                            {{ item.acreditado?.nombre || '&nbsp;' }}
                          </div>
                          <div>
                            {{ item.acreditado?.apellido || '&nbsp;' }}
                          </div>
                          <div>
                            {{ item.acreditado?.empresa || '&nbsp;' }}
                          </div>
                          <div class="text-xs text-gray-500 dark:text-gray-500 mt-1">
                            {{ item.acreditado?.tipoAcreditado?.descripcion || '&nbsp;' }}
                          </div>
                          <div class="w-full flex flex-col mt-1">
                            <a @click="eliminarAcreditado(item.acreditado)" v-if="item.acreditado" class="py-1 mt-2 block rounded border border-red-500 bg-transparent text-red-500 hover:bg-red-500 hover:text-white cursor-pointer">
                              <font-awesome-icon :icon="['fas', 'user-minus']" /> ELIMINAR
                            </a>
                            <a @click="asignarInvitacion(item)" v-if="!item.acreditado" class="py-1 mt-2 block rounded border border-green-600 bg-transparent text-green-600 hover:bg-green-600 hover:text-white cursor-pointer">
                              <font-awesome-icon :icon="['fas', 'user-plus']" /> ASIGNAR
                            </a>
                            <a @click="enviarCorreo(item.acreditado)" v-if="item.acreditado" class="py-1 mt-2 block rounded border border-green-600 bg-transparent text-green-600 hover:bg-green-600 hover:text-white cursor-pointer">
                              <font-awesome-icon :icon="['far', 'envelope']" /> ENVIAR MAIL
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </DataView>

            </div>
          </div>
          <!-- FIN FORM GESTIÓN INVITACIONES -->

          <!-- FORM GESTIÓN DE ARCHIVOS -->
          <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 mt-4 mb-10" v-if="grupoInvitacionSeleccionado && grupoInvitacionSeleccionado.permiteSubirArchivos">
            <div class="flex items-center justify-between font-semibold text-lg ">
              GESTIÓN DE ARCHIVOS
            </div>

            <div class="container mx-auto block w-full mt-4 space-y-4">

              <div v-if="archivosGruposInvitaciones?.length == 0">
                <div class="w-full py-5 text-2xl font-semibold text-center text-gray-500">
                  Todavía no hay archivos subidos
                </div>
              </div>

              <div v-if="archivosGruposInvitaciones?.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm">

              <div v-for="archivoGrupoInvitacion in archivosGruposInvitaciones" v-bind:key="archivoGrupoInvitacion.id" :archivoGrupoInvitacion="archivoGrupoInvitacion">
                <div class="p-3 w-full bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">
                  <div class="flex flex-col w-full">
                    <div>
                      <font-awesome-icon :icon="['far', 'file']" class="text-2xl" />
                    </div>
                    <div class="text-base">
                      {{archivoGrupoInvitacion.descripcion}}
                    </div>
                    <div class="text-xs text-gray-500">
                      {{formatDate(archivoGrupoInvitacion.fechaAlta, 'dd/MM/yyyy HH:mm:ss')}}
                    </div>
                    <div class="text-xs rounded-md text-white p-0.5 mt-1" :style="{ backgroundColor: archivoGrupoInvitacion.estadoArchivoGrupoInvitacion.color }">
                      {{archivoGrupoInvitacion.estadoArchivoGrupoInvitacion.descripcion}}
                    </div>

                    <div class="w-full flex flex-col mt-1">
                      <a @click="bajarArchivoGrupos(archivoGrupoInvitacion)" class="py-1 mt-2 text-xs block rounded border border-green-600 bg-transparent text-green-600 hover:bg-green-600 hover:text-white cursor-pointer">
                        <font-awesome-icon :icon="['fas', 'download']" />
                        DESCARGAR
                      </a>
                      
                      <a v-if="archivoGrupoInvitacion.estadoArchivoGrupoInvitacion?.id == 1" @click="eliminarArchivoPregunta(archivoGrupoInvitacion)" class="py-1 mt-2 text-xs block rounded border border-red-500 bg-transparent text-red-500 hover:bg-red-500 hover:text-white cursor-pointer">
                        <font-awesome-icon :icon="['fas', 'trash-can']" />
                        ELIMINAR
                      </a>
                      <a v-if="archivoGrupoInvitacion.estadoArchivoGrupoInvitacion?.id != 1" @click="verObservaciones(archivoGrupoInvitacion)" class="py-1 mt-2 text-xs block rounded border border-green-600 bg-transparent text-green-600 hover:bg-green-600 hover:text-white cursor-pointer">
                        <font-awesome-icon :icon="['far', 'comment']" />
                        VER OBSERVACIONES
                      </a>

                    </div>
                  </div>
                </div>
              </div>

              </div>

              <div class="w-full flex flex-col lg:flex-row gap-2 pb-2 text-center">
                <a @click="isFileUploadVisible = true" class="cursor-pointer py-2 px-4 rounded border border-green-600 bg-white text-green-600 hover:bg-green-800 hover:text-white">
                  <font-awesome-icon :icon="['fas', 'upload']" />
                  SUBIR ARCHIVO
                </a>
              </div>

            </div>
          </div>
          <!-- FIN FORM GESTIÓN DE ARCHIVOS -->

      </div>
      

    </template>
  </CommonPrivateView>

  <BlockUI :blocked="isSubmitting" fullScreen/>
  
  <ModalFileUpload :visible="isFileUploadVisible" :askDescription="true" :forceSquare="false" 
        :maxSizeMB="5" :fileTypes="['image/png', 'image/jpg', 'image/jpeg', 'application/pdf']"
        :onAccept="onFileUploadAcepted" @update:visible="isFileUploadVisible = $event" />

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swal from 'sweetalert2'

import BlockUI from 'primevue/blockui';
import DataView from 'primevue/dataview';
import InputText from 'primevue/inputtext';
import InputGroup from 'primevue/inputgroup';
import Button from 'primevue/button';

import ModalFileUpload from "@/components/commons/ModalFileUpload.vue";
import CommonPrivateView from '@/components/commons/CommonPrivateView.vue';

import invitacionService, { GrupoInvitacion, Invitacion } from 'qreventos-suite/invitaciones';
import suiteConfig from '@/services/suite.config';
import suiteService, { Acreditado, Evento } from 'qreventos-suite/services';
import seguridadServices from '@/services/seguridad.services';
import eventoServices from 'qreventos-suite/eventos';
import { ArchivoGrupoInvitacion, UsuarioEmpresa } from 'qreventos-suite/src/services/suite.interfaces';
import { formatDate } from '@/utils/formatters';

export default defineComponent({
  components: {
    DataView, InputText, InputGroup,
    BlockUI, Button,
    ModalFileUpload,
    CommonPrivateView
  },
  created() {
    document.title = "Empresas";
  },
  data() {
    return {
      isSubmitting: false,
      isFileUploadVisible: false,
      evento: undefined as unknown as Evento,
      verInvitacionesUsadas: true,
      gruposInvitaciones: [] as GrupoInvitacion[],
      grupoInvitacionSeleccionado: undefined as unknown as GrupoInvitacion,
      invitaciones: [] as Invitacion[],
      invitacionesFiltradas: [] as Invitacion[],
      totalInvitaciones: 0,
      totalUsadas: 0,
      totalDisponibles: 0,
      filtroTexto: '',
      archivosGruposInvitaciones: [] as ArchivoGrupoInvitacion[],
      invitacionUnica: undefined as unknown as Invitacion,
      usuarioEmpresa: undefined as unknown as UsuarioEmpresa
    };
  },
  methods: {
    formatDate,
    async cambiarGrupoInvitacion(grupoInvitacion:GrupoInvitacion) {
      this.grupoInvitacionSeleccionado = grupoInvitacion;
      this.reload();
    },
    async verDisponibles() {
      this.verInvitacionesUsadas = false;
      this.invitacionesFiltradas = this.invitaciones.filter(invitacion => invitacion.acreditado == null);
    },
    async verUsadas() {
      this.verInvitacionesUsadas = true;
      this.invitacionesFiltradas = this.invitaciones.filter(invitacion => invitacion.acreditado !== null);
    },
    async limpiarFiltro() {
      this.filtroTexto = '';

      if(this.verInvitacionesUsadas) {
        this.invitacionesFiltradas = this.invitaciones.filter(invitacion => invitacion.acreditado !== null);
      } else {
        this.invitacionesFiltradas = this.invitaciones.filter(invitacion => invitacion.acreditado == null);
      }

    },
    async filtrar() {
      if(this.filtroTexto == '') {
        this.limpiarFiltro();
        return;
      }

      if(this.verInvitacionesUsadas) {
        this.invitacionesFiltradas = this.invitaciones.filter(invitacion => 
            invitacion.acreditado !== null && (
            invitacion.codigoInvitacion.toLowerCase().indexOf(this.filtroTexto.toLowerCase()) != -1 ||
            invitacion.acreditado.codigoAcreditado.toLowerCase().indexOf(this.filtroTexto.toLowerCase()) != -1 ||
            invitacion.acreditado.nombre.toLowerCase().indexOf(this.filtroTexto.toLowerCase()) != -1 ||
            (invitacion.acreditado.dni?.toLowerCase() || "").includes(this.filtroTexto.toLowerCase()) ||
            invitacion.acreditado.apellido.toLowerCase().indexOf(this.filtroTexto.toLowerCase()) != -1
          ));
      } else {
        this.invitacionesFiltradas = this.invitaciones.filter(invitacion => 
            invitacion.acreditado == null && 
            invitacion.codigoInvitacion.toLowerCase().indexOf(this.filtroTexto.toLowerCase()) != -1);
      }
    },
    async reloadArchivos() {
      if(this.grupoInvitacionSeleccionado && this.grupoInvitacionSeleccionado.id) {
        this.archivosGruposInvitaciones = await invitacionService.findArchivosGruposInvitacionesBy(this.grupoInvitacionSeleccionado.id);  
        this.archivosGruposInvitaciones = this.archivosGruposInvitaciones.slice().sort((a, b) => new Date(b.fechaAlta).getTime() - new Date(a.fechaAlta).getTime());
      }
    },
    async reload() {
      try {
        this.isSubmitting = true;

        this.grupoInvitacionSeleccionado = await invitacionService.findGrupoInvitacionById(this.usuarioEmpresa.evento.id, this.grupoInvitacionSeleccionado.id);
        this.invitaciones  = this.grupoInvitacionSeleccionado.invitaciones;
        this.invitacionesFiltradas = this.invitaciones.filter(invitacion => invitacion.acreditado !== null);

        if(this.grupoInvitacionSeleccionado.permiteSubirArchivos) {
          this.reloadArchivos();
        }

        if(!this.grupoInvitacionSeleccionado.secuencia) {
          this.invitacionUnica = await invitacionService.findInvitacionUnicaBy(this.usuarioEmpresa.evento.id, this.grupoInvitacionSeleccionado.id);
        }        
        
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    async liberarInvitacion(acreditado:Acreditado) {
      try {
        const liberarResponse:String = await invitacionService.liberarInvitacionBy(this.grupoInvitacionSeleccionado.evento.id, acreditado.id) as String;
        if(liberarResponse == "Ok") {
          Swal.fire({ title: '¡Atención!', html: `Invitación liberada con éxito`, icon: 'info' })
            .then(() => {
              this.reload();
          });
        }
      }
      catch (error) {
        Swal.fire({ title: "Error", text: "" + error + "", icon: "error" })
          .then(() => {
            this.reload();
          });
      }  
    },
    async eliminarAcreditado(acreditado:Acreditado) {
      Swal.fire({
        title: '¡Atención!',
        html: `¿Seguro que desea rechazar al acreditado <b>${acreditado.nombre} ${acreditado.apellido} (${acreditado.codigoAcreditado})</b>?<br/><br/>Esta operación es irreversible.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'SI, RECHAZARLO!',
        cancelButtonText: 'CANCELAR',
        buttonsStyling: true
      }).then((isConfirm) => {
        if (isConfirm.value === true) {
          this.liberarInvitacion(acreditado);
        }
      });
    },
    async agregarInvitado() {
      if(!this.invitacionUnica) {
        Swal.fire({title: '¡Atención!', html: `La empresa no tiene invitaciones asigandas.`, icon: 'question'});
        return;
      }

      this.$router.push({ path: '/asignarInvitacion/'+ this.grupoInvitacionSeleccionado.id +'/' + this.invitacionUnica.id });

/*      Swal.fire({
        title: '¡Atención!',
        html: `¿Desea agregar un invitado con el código de invitación <b>${this.invitacionUnica.codigoInvitacion}</b>?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: 'green',
        confirmButtonText: 'SI, AGREGAR!',
        cancelButtonText: 'CANCELAR',
        buttonsStyling: true
      }).then((isConfirm) => {
        if (isConfirm.value === true) {
          
        
        }
      });*/

    },
    async asignarInvitacion(invitacion:Invitacion) {
      Swal.fire({
        title: '¡Atención!',
        html: `¿Desea asginar la invitación <b>${invitacion.codigoInvitacion}</b> a un nuevo acreditado?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: 'green',
        confirmButtonText: 'SI, ASIGNAR!',
        cancelButtonText: 'CANCELAR',
        buttonsStyling: true
      }).then((isConfirm) => {
        if (isConfirm.value === true) {
          this.$router.push({ path: '/asignarInvitacion/' + this.grupoInvitacionSeleccionado.id + '/' + invitacion.id });
        }
      });
    },
    async bajarArchivoGrupos(archivoGrupoInvitacion:ArchivoGrupoInvitacion) { 
      window.location.href = invitacionService.getFileUrl(archivoGrupoInvitacion.id);
    },
    async verObservaciones(archivoGrupoInvitacion:ArchivoGrupoInvitacion) {
      if(!archivoGrupoInvitacion.observaciones) {
        Swal.fire({ title: '¡Atención!', html: "El archivo fue <b>" + archivoGrupoInvitacion.estadoArchivoGrupoInvitacion.descripcion + "</b> sin observaciones.", icon: 'info'});
        return;
      }

      Swal.fire({ title: "Observaciones", html: archivoGrupoInvitacion.observaciones, icon: 'info'});
    },
    async eliminarArchivoPregunta(archivoGrupoInvitacion:ArchivoGrupoInvitacion) {
      Swal.fire({
        title: '¡Atención!',
        html: `¿Desea eliminar el archivo <b>${archivoGrupoInvitacion.descripcion}</b>?<br/>Esta operación es irreversible.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: 'green',
        confirmButtonText: 'SI, ELIMINAR!',
        cancelButtonText: 'CANCELAR',
        buttonsStyling: true
      }).then((isConfirm) => {
        if (isConfirm.value === true) {          
          this.eliminarArchivo(archivoGrupoInvitacion);
        }
      });
    },
    async eliminarArchivo(archivoGrupoInvitacion:ArchivoGrupoInvitacion) {
      try {
        await invitacionService.removeFile(archivoGrupoInvitacion);
        Swal.fire({ title: '¡Atención!', html: `Archivo eliminado con éxito`, icon: 'info'}).then(() => {
          this.reloadArchivos();
        });
      }
      catch (error) {
        Swal.fire({ title: "Error", text: "" + error + "", icon: "error" })
          .then(() => {
            this.reload();
          });
      }
    },
    async onFileUploadAcepted(base64: string, fileName: string, descripcion: string) {
      base64 = base64.split(',')[1];

      const archivoGrupoInvitacion:ArchivoGrupoInvitacion = {} as ArchivoGrupoInvitacion;
      archivoGrupoInvitacion.descripcion = descripcion;
      archivoGrupoInvitacion.evento = this.grupoInvitacionSeleccionado.evento;
      archivoGrupoInvitacion.grupoInvitacion = this.grupoInvitacionSeleccionado;
      archivoGrupoInvitacion.fileName = new Date().getTime() + "_" + fileName.replace(/[^a-zA-Z0-9.]/g, '');
      archivoGrupoInvitacion.fileDataBase64 = base64;

      try {
        await invitacionService.subirArchivo(archivoGrupoInvitacion);
        Swal.fire({ title: '¡Atención!', html: `Archivo subido con éxito`, icon: 'info'}).then(() => {
          this.reloadArchivos();
        });
      }
      catch (error) {
        Swal.fire({ title: "Error", text: "" + error + "", icon: "error" })
          .then(() => {
            this.reload();
          });
      }
    },
    async notificar(acreditado:Acreditado, mail:string) {
      try {
        await suiteService.notificar(this.grupoInvitacionSeleccionado.evento.id, acreditado.id, mail);
        Swal.fire({ title: '¡Atención!', html: `Mail enviado con éxito`, icon: 'info'});
      }
      catch (error) {
        Swal.fire({ title: "Error", text: "" + error + "", icon: "error" })
          .then(() => {
            this.reload();
          });
      }  
    },
    async enviarCorreo(acreditado:Acreditado) {
      let mail:string = acreditado.mail;
      if(!mail) {
        mail = "";
      }

      Swal.fire({
        title: 'Enviar correo a',
        showCancelButton: true,
        confirmButtonColor: "green",
        confirmButtonText: 'ENVIAR',
        cancelButtonText: 'CANCELAR',
        html: '<input id="swal_descripcion" class="swal2-input w-full max-w-lg mx-auto focus:outline-none" placeholder="Mail" value="' +  mail + '" style="box-shadow: none;" />' ,
        focusConfirm: false,
        preConfirm: () => {				
          mail = (document.getElementById('swal_descripcion') as HTMLInputElement).value;
          if (mail == "") {
            Swal.showValidationMessage("El mail no puede estar vacío." + mail);
          } else {
            this.notificar(acreditado, mail);
          }
        }
      });
    },    
    async downloadExcel() {
      if(!this.grupoInvitacionSeleccionado) {
        Swal.fire({title: '¡Atención!', html: `La empresa no tiene invitaciones asigandas.`, icon: 'question'});
        return;
      }

      window.location.href = invitacionService.getReporteUrl(this.grupoInvitacionSeleccionado.evento.id, this.grupoInvitacionSeleccionado.id) as string;
    }
  },
  async mounted() {
    try {      
      invitacionService.clientId = suiteConfig.clientId;
      invitacionService.token = suiteConfig.token;

      eventoServices.clientId = suiteConfig.clientId;
      eventoServices.token = suiteConfig.token;

      this.usuarioEmpresa = seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa;
      this.evento = await eventoServices.validarEvento(this.usuarioEmpresa.evento.id);

      this.gruposInvitaciones = await invitacionService.findGruposInvitacionesBy(this.usuarioEmpresa);
      if(this.gruposInvitaciones.length > 0) {

        this.gruposInvitaciones = this.gruposInvitaciones.slice().sort((a, b) => a.descripcion.localeCompare(b.descripcion));

        const idGrupoInvitacion:number = Number(this.$route.params.idGrupoInvitacion);
        if(idGrupoInvitacion) {
          const grupoInvitacion:GrupoInvitacion = this.gruposInvitaciones.find(x => x.id === idGrupoInvitacion) as GrupoInvitacion;
          if(grupoInvitacion) {
            this.grupoInvitacionSeleccionado = grupoInvitacion;
          }
        }
        
        if(!this.grupoInvitacionSeleccionado) {
          this.grupoInvitacionSeleccionado = this.gruposInvitaciones[0];
        }

        await this.reload();
      }
    }
    catch (error) {
      Swal.fire({ title: "Error", text: 'Sesión expirada [' + error + ']', icon: "error" })
        .then(() => {
          seguridadServices.logout();
          this.$router.push({ path: '/' });
        });
    }    
  }
});
</script>
